import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Commessa, Utente, TipoCliente, TipoIntervento, RecursiveCommessa, OrdineLavoro } from 'src/app/def/structures';

import { DBFirestoreService } from 'src/app/dbfirestore.service';
import {
    ButtonType,
    EventOrdine,
    EventEditCommessa,
    EventCommessa,
    EventAddCommessa,
    EventDeleteCommessa,
    EventAddOrdine,
    EventDeleteOrdine,
    EventEditOrdine
} from 'src/app/def/types';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { NgbDatepickerDayView } from '@ng-bootstrap/ng-bootstrap/datepicker/datepicker.module';
import { Subscription, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NgForm } from '@angular/forms';


@Component({
    selector: 'odl-form',
    templateUrl: './odl-form.component.html',
    styleUrls: ['./odl-form.component.scss']
})

export class OdlFormComponent implements OnInit, OnDestroy {

    @Input() buttons: ButtonType[];
    // @Input() recursive_commessa: RecursiveCommessa;
    @Output() onSave = new EventEmitter<EventEditCommessa>();
    @Output() onCancel = new EventEmitter<boolean>();
    @Output() onCreate = new EventEmitter<EventAddCommessa>();
    @Output() onDelete = new EventEmitter<EventDeleteCommessa>();

    utenti: Utente[];
    tipi_cliente: TipoCliente[];
    tipi_intervento: TipoIntervento[];

    commessa: Partial<Commessa>;
    ordini: OrdineLavoro[];

    order_dates_list: {
        date: Date,
        id?: string,
        pendingDelete: boolean,
        pendingCreate: boolean,
        confirmed: boolean
    }[] = [];
    order_dates_list_idx: { [s: string]: number } = {};

    pickerdate: NgbDate;


    private unsubscribe$ = new Subject<void>();

    constructor(
        private db: DBFirestoreService,
        private datepipe: DatePipe
    ) {
    }

    @Input()
    set recursive_commessa(recursive_commessa: RecursiveCommessa) {

        this.commessa = recursive_commessa ? recursive_commessa.commessa : null;
        this.ordini = recursive_commessa ? recursive_commessa.ordini : [];
        this.order_dates_list = [];

        this.ordini.forEach(ordine => {

            this.order_dates_list.push({
                date: ordine.giorno_ora,
                pendingDelete: false,
                id: ordine.id,
                pendingCreate: false,
                confirmed: ordine.confermato ? true : false,
            });

            this.order_dates_list_idx['_' + this.datepipe.transform(ordine.giorno_ora, 'yyyyMMdd')] = this.order_dates_list.length - 1;
        })

    }

    ngOnInit() {
        this.db.collectionCachedUtenti()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(results => this.utenti = results);

        this.db.collectionCachedTipiCliente()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(results => this.tipi_cliente = results);

        this.db.collectionCachedTipiIntervento()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(results => this.tipi_intervento = results);
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }


    setDataRicezione(strData: string) {
        if (strData) {
            const [yyyy, mm, dd]: string[] = strData.split('-');

            if (dd && mm && yyyy) {
                const data = new Date();
                data.setDate(1); // Temporaneamente impostiamo un giorno valido per qualunque mese/anno
                data.setFullYear(parseInt(yyyy, 0));
                data.setMonth(parseInt(mm, 0) - 1);
                data.setDate(parseInt(dd, 0));

                data.setHours(0);
                data.setMinutes(0);
                data.setSeconds(0);

                this.commessa.data_ricezione = data;
            }

        }
    }

    onClick(type: ButtonType, formstatus?: NgForm) {

        switch (type) {
            case 'cancel':
                this.onCancel.emit(formstatus.dirty);
                break;
            case 'create':
                if (!this.confirmPastDates()) {
                    return;
                    break;
                }
                this.onCreate.emit({
                    type: 'add',
                    data: this.commessa,
                    ordini: this.eventCreateOrders()
                });
                break;
            case 'delete':
                this.onDelete.emit({
                    type: 'delete',
                    id: this.commessa.id,
                    ordini: this.eventDeleteOrders()
                });
                break
            case 'save':
                if (!this.confirmPastDates()) {
                    return;
                    break;
                }
                this.onSave.emit({
                    type: 'edit',
                    id: this.commessa.id,
                    data: this.commessa,
                    ordini: this.eventUpdateOrders()
                });
                break;
        }
    }

    isSelected(date: NgbDate) {
        if (!date.day || !date.month || !date.year) {
            return false;
        }
        const stringDate = '_' + date.year.toString() + date.month.toString().padStart(2, '0') + date.day.toString().padStart(2, '0');
        const idx = this.order_dates_list_idx[stringDate];
        return idx !== undefined && this.order_dates_list[idx] && this.order_dates_list[idx].id;
    }

    isConfirmed(date: NgbDate) {
        if (!date.day || !date.month || !date.year) {
            return false;
        }
        const stringDate = '_' + date.year.toString() + date.month.toString().padStart(2, '0') + date.day.toString().padStart(2, '0');
        const idx = this.order_dates_list_idx[stringDate];
        return idx !== undefined && this.order_dates_list[idx] && this.order_dates_list[idx].confirmed;
    }

    isPendingUpdate(date: NgbDate) {
        const stringDate = '_' + date.year.toString() + date.month.toString().padStart(2, '0') + date.day.toString().padStart(2, '0');
        const idx = this.order_dates_list_idx[stringDate];
        return idx !== undefined && this.order_dates_list[idx] && (this.order_dates_list[idx].pendingCreate || this.order_dates_list[idx].pendingDelete);
    }

    toggleStatus(date: NgbDate) {

        const stringDate = '_' + date.year.toString() + date.month.toString().padStart(2, '0') + date.day.toString().padStart(2, '0');
        const idx = this.order_dates_list_idx[stringDate];

        if (idx !== undefined) {  // Se la data è già presente, va eliminata

            // Se è una data in attesa di essere creata, la elimino dall'array e ricreo l'indice
            if (this.order_dates_list[idx].pendingCreate) {

                this.order_dates_list.splice(idx, 1);
                this.reindexOrderDatesList();

                // Se è una data già creata a db nego (alterno) la condizione di "in attesa di cancellazione"
            } else {
                this.order_dates_list[idx].pendingDelete = !this.order_dates_list[idx].pendingDelete;
            }

        } else {    // Se la data non è presente, va aggiunta
            const newdate = new Date();

            newdate.setDate(1); // Temporaneamente impostiamo un giorno valido per qualunque mese/anno
            newdate.setFullYear(date.year);
            newdate.setMonth(date.month - 1);
            newdate.setDate(date.day);

            newdate.setHours(0);
            newdate.setMinutes(0);
            newdate.setSeconds(0);

            this.order_dates_list.push({
                date: newdate,
                pendingDelete: false,
                pendingCreate: true,
                confirmed: false,
            });

            this.order_dates_list.sort((a, b) => {
                const adate = new NgbDate(a.date.getFullYear(), a.date.getMonth() + 1, a.date.getDate());
                const bdate = new NgbDate(b.date.getFullYear(), b.date.getMonth() + 1, b.date.getDate());
                return adate.after(bdate) ? 1 : -1;
            });
            this.reindexOrderDatesList();

        }


    }

    reindexOrderDatesList() {
        this.order_dates_list_idx = {};

        this.order_dates_list.map((value, i) => {
            const stringDate = '_' + this.datepipe.transform(value.date, 'yyyyMMdd');
            this.order_dates_list_idx[stringDate] = i;
        })
    }

    eventUpdateOrders(): EventOrdine[] {
        const retval: EventOrdine[] = [];

        this.order_dates_list.forEach(odata => {
            if (odata.pendingDelete) {
                const event: EventDeleteOrdine = {
                    type: 'delete',
                    id: odata.id,
                    parent_id: this.commessa.id,
                }
                retval.push(event);
            }
            if (odata.pendingCreate) {
                const event: EventAddOrdine = {
                    type: 'add',
                    date: odata.date,
                    parent_id: this.commessa.id,
                    default: {
                        indirizzo: this.commessa.indirizzo,
                        localita: this.commessa.localita,
                        telefono: this.commessa.telefono,
                        persona_riferimento: this.commessa.persona_riferimento,
                        note: this.commessa.note,
                    }
                }
                retval.push(event);
            }

            if (!odata.pendingCreate && !odata.pendingDelete && !odata.confirmed) {
                const event: EventEditOrdine = {
                    type: 'edit',
                    id: odata.id,
                    parent_id: this.commessa.id,
                    data: {
                        indirizzo: this.commessa.indirizzo,
                        localita: this.commessa.localita,
                        telefono: this.commessa.telefono,
                        persona_riferimento: this.commessa.persona_riferimento,
                        note: this.commessa.note,
                    }
                }
                retval.push(event);
            }
        })

        return retval;
    }

    eventDeleteOrders(): EventDeleteOrdine[] {
        return this.order_dates_list.map(odata => {
            return {
                type: 'delete',
                id: odata.id,
                parent_id: this.commessa.id,
            }
        });
    }

    eventCreateOrders(): EventAddOrdine[] {
        return this.order_dates_list.map(odata => {
            return {
                type: 'add',
                date: odata.date,
                parent_id: this.commessa.id,
            }
        });
    }

    // Fake submit to trigger browser autocomplete
    onSubmit(event: Event) {
        event.preventDefault();
        return false;
    }


    confirmPastDates() {
        const today = new Date();
        today.setHours(0);
        today.setMinutes(0);
        today.setSeconds(0);
        today.setMilliseconds(0);
        let valid = true;
        this.order_dates_list.map(odata => {
            if (odata.pendingCreate && (today > odata.date)) {
                valid = false;
            }
        })
        if (!valid) {

            valid = confirm('Stai tentando di aggiungere una o più date nel passato. Sei sicuro di voler procedere?');
        }

        return valid;
    }
}
